module.exports = __webpack_public_path__ + "media/images/icons/cloud-upload-da01af969b831132412f944319a95f53.svg";